import { render, staticRenderFns } from "./finalidades.vue?vue&type=template&id=dec7a79e&scoped=true&"
import script from "./finalidades.vue?vue&type=script&lang=ts&"
export * from "./finalidades.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dec7a79e",
  null
  
)

export default component.exports